import { ScopeBySector } from '../scopes-types';

export const SCOPES_VENUE_DATES: ScopeBySector = {
  '': {},
  ANY: {},
  TEAM: {},
  ARTISTS: {
    all: 'VENUE-DATES-ARTISTS',
    mobility: 'VENUE-DATES-ARTISTS-MOBILITY',
    catering: 'VENUE-DATES-ARTISTS-CATERING',
    accommodation: 'VENUE-DATES-ARTISTS-ACCOMMODATION',
    cargo: 'VENUE-DATES-ARTISTS-CARGO',
  },
  SITE: {},
  PUBLIC: {},
};
